"use strict";

exports.__esModule = true;
exports.layoutTwoRows = exports.layoutTopRowTwoTiles = exports.layoutThreeRows = exports.layoutThreeColumns = exports.layoutRightColumnTwoTiles = exports.layoutLeftColumnTwoTiles = exports.layoutBottomRowTwoTiles = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var layoutTwoRows = exports.layoutTwoRows = /*#__PURE__*/_react["default"].createElement("span", {
  className: "bp6-icon"
}, /*#__PURE__*/_react["default"].createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M0 1C0 0.447715 0.447715 0 1 0H19C19.5523 0 20 0.447715 20 1V8C20 8.55228 19.5523 9 19 9H1C0.447716 9 0 8.55228 0 8V1Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M0 12C0 11.4477 0.447715 11 1 11H19C19.5523 11 20 11.4477 20 12V19C20 19.5523 19.5523 20 19 20H1C0.447716 20 0 19.5523 0 19V12Z"
})));
var layoutThreeColumns = exports.layoutThreeColumns = /*#__PURE__*/_react["default"].createElement("span", {
  className: "bp6-icon"
}, /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M12 1C12 0.447715 12.4477 0 13 0H15C15.5523 0 16 0.447715 16 1V15C16 15.5523 15.5523 16 15 16H13C12.4477 16 12 15.5523 12 15V1Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M6 1C6 0.447715 6.44772 0 7 0H9C9.55228 0 10 0.447715 10 1V15C10 15.5523 9.55228 16 9 16H7C6.44772 16 6 15.5523 6 15V1Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M0 1C0 0.447715 0.447715 0 1 0H3C3.55228 0 4 0.447715 4 1V15C4 15.5523 3.55228 16 3 16H1C0.447715 16 0 15.5523 0 15V1Z"
})));
var layoutThreeRows = exports.layoutThreeRows = /*#__PURE__*/_react["default"].createElement("span", {
  className: "bp6-icon"
}, /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M15 12C15.5523 12 16 12.4477 16 13V15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15V13C0 12.4477 0.447715 12 1 12H15Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M15 6C15.5523 6 16 6.44772 16 7V9C16 9.55228 15.5523 10 15 10H1C0.447715 10 0 9.55228 0 9V7C0 6.44772 0.447715 6 1 6H15Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M15 0C15.5523 0 16 0.447715 16 1V3C16 3.55228 15.5523 4 15 4H1C0.447715 4 0 3.55228 0 3V1C0 0.447715 0.447715 0 1 0H15Z"
})));
var layoutBottomRowTwoTiles = exports.layoutBottomRowTwoTiles = /*#__PURE__*/_react["default"].createElement("span", {
  className: "bp6-icon"
}, /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M6 9C6.55228 9 7 9.44772 7 10V15C7 15.5523 6.55228 16 6 16H1C0.447715 16 0 15.5523 0 15V10C0 9.44772 0.447715 9 1 9H6Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M15 9C15.5523 9 16 9.44772 16 10V15C16 15.5523 15.5523 16 15 16H10C9.44772 16 9 15.5523 9 15V10C9 9.44772 9.44772 9 10 9H15Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M15 0C15.5523 0 16 0.447715 16 1V6C16 6.55228 15.5523 7 15 7H1C0.447715 7 0 6.55228 0 6V1C0 0.447715 0.447715 0 1 0H15Z"
})));
var layoutLeftColumnTwoTiles = exports.layoutLeftColumnTwoTiles = /*#__PURE__*/_react["default"].createElement("span", {
  className: "bp6-icon"
}, /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M7 1C7 0.447715 6.55228 0 6 0H1C0.447715 0 0 0.447715 0 1V6C0 6.55228 0.447715 7 1 7H6C6.55228 7 7 6.55228 7 6V1Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M7 10C7 9.44772 6.55228 9 6 9H1C0.447715 9 0 9.44772 0 10V15C0 15.5523 0.447715 16 1 16H6C6.55228 16 7 15.5523 7 15V10Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M16 1C16 0.447715 15.5523 0 15 0H10C9.44772 0 9 0.447715 9 1V15C9 15.5523 9.44772 16 10 16H15C15.5523 16 16 15.5523 16 15V1Z"
})));
var layoutRightColumnTwoTiles = exports.layoutRightColumnTwoTiles = /*#__PURE__*/_react["default"].createElement("span", {
  className: "bp6-icon"
}, /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M9 1C9 0.447715 9.44772 0 10 0H15C15.5523 0 16 0.447715 16 1V6C16 6.55228 15.5523 7 15 7H10C9.44772 7 9 6.55228 9 6V1Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M9 10C9 9.44772 9.44772 9 10 9H15C15.5523 9 16 9.44772 16 10V15C16 15.5523 15.5523 16 15 16H10C9.44772 16 9 15.5523 9 15V10Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M0 1C0 0.447715 0.447715 0 1 0H6C6.55228 0 7 0.447715 7 1V15C7 15.5523 6.55228 16 6 16H1C0.447715 16 0 15.5523 0 15V1Z"
})));
var layoutTopRowTwoTiles = exports.layoutTopRowTwoTiles = /*#__PURE__*/_react["default"].createElement("span", {
  className: "bp6-icon"
}, /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M10 7C9.44772 7 9 6.55228 9 6V1C9 0.447715 9.44772 -4.82823e-08 10 0L15 4.37114e-07C15.5523 4.85396e-07 16 0.447716 16 1V6C16 6.55229 15.5523 7 15 7L10 7Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M1 7C0.447715 7 -4.82823e-08 6.55228 0 6L4.37114e-07 1C4.85396e-07 0.447715 0.447716 -4.82823e-08 1 0L6 4.37114e-07C6.55229 4.85396e-07 7 0.447716 7 1L7 6C7 6.55229 6.55228 7 6 7L1 7Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M1 16C0.447715 16 -4.82823e-08 15.5523 0 15L4.37114e-07 10C4.85396e-07 9.44772 0.447716 9 1 9L15 9C15.5523 9 16 9.44772 16 10V15C16 15.5523 15.5523 16 15 16L1 16Z"
})));